module.exports = __webpack_public_path__ + "img/header.88e042ed.png";